import { useState } from "react";
import {
  signInWithEmailAndPassword,
  setPersistence,
  browserLocalPersistence,
  browserSessionPersistence,
  sendPasswordResetEmail,
} from "firebase/auth";
import { auth, db } from "./firebase";
import { doc, getDoc, setDoc } from "firebase/firestore";
import { Link, useNavigate } from "react-router-dom";
import { sendEmailVerification } from "firebase/auth";
import "./Login.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [rememberMe, setRememberMe] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
  e.preventDefault();
  setError("");

  try {
    const persistenceType = rememberMe
      ? browserLocalPersistence
      : browserSessionPersistence;

    await setPersistence(auth, persistenceType);

    const userCredential = await signInWithEmailAndPassword(
      auth,
      email,
      password
    );

    const user = userCredential.user;

    if (!user.emailVerified) {
      await auth.signOut();
      setError(
        "⚠️ Your email isn’t verified yet. Please check your inbox and verify your email before logging in, the mail might be in spam."
      );
      return;
    }

    navigate("/VolunteerHours");
  } catch (err) {
    console.error(err.code, err.message);

    if (err.code === "auth/wrong-password") {
      setError("Incorrect password.");
    } else if (err.code === "auth/user-not-found") {
      setError("No account found with this email.");
    } else if (err.code === "auth/too-many-requests") {
      setError("Too many attempts. Please try again later.");
    } else {
      setError(err.message);
    }
  }
};

  const handleForgotPassword = async () => {
    if (!email) {
      setError("Please enter your email first.");
      return;
    }

    try {
      await sendPasswordResetEmail(auth, email);
      alert("Password reset email sent! Check your inbox.");
    } catch (err) {
      setError(err.message);
    }
  };

  // const handleGoogleSignIn = async () => {
  //   const provider = new GoogleAuthProvider();
  //   setError("");

  //   try {
  //     const result = await signInWithPopup(auth, provider);
  //     const user = result.user;

  //     const userRef = doc(db, "users", user.uid);
  //     const userSnap = await getDoc(userRef);

  //     if (!userSnap.exists()) {
  //       await setDoc(userRef, {
  //         profile: {
  //           email: user.email,
  //           name: user.displayName,
  //           volunteerHours: 0,
  //           createdAt: new Date(),
  //         },
  //       });
  //     }

  //     navigate("/VolunteerHours");
  //   } catch (err) {
  //     setError(err.message);
  //   }
  // };

  return (
    <div className="login-container">
      <div className="login-left">
        <h1 className="login-heading">Log In</h1>
        <h2>Welcome Back</h2>
        <p>Enter your email and password to access your account.</p>

        {error && <p className="error">{error}</p>}

        <form onSubmit={handleLogin}>
          <label>Email</label>
          <input
            type="email"
            placeholder="you@example.com"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />

          <label>Password</label>
          <input
            type="password"
            placeholder="Enter your password"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
          />

          <div className="login-options">
            <label>
              <input
                type="checkbox"
                checked={rememberMe}
                onChange={(e) => setRememberMe(e.target.checked)}
              />{" "}
              Remember Me
            </label>
            <button
              type="button"
              className="forgot-password-link"
              onClick={handleForgotPassword}
            >
              Forgot your password?
            </button>
          </div>

          <button type="submit" className="login-btn">
            Log In
          </button>

          {/* <div className="divider"></div>

          <button
            type="button"
            className="google-btn"
            onClick={handleGoogleSignIn}
          >
            Sign in with Google
          </button> */}

          <p className="signup-link">
            Don’t have an account? <Link to="/Register">Register now</Link>
          </p>
        </form>
      </div>

      <div className="login-right">
        <div className="overlay-text">
          <h2>Effortlessly manage your quizzes and hours</h2>
          <p>Log in to access your dashboard and manage your courses.</p>
        </div>
      </div>
    </div>
  );
};

export default Login;
